(function(){
    'use strict';

/**
* @memberof app
* @ngdoc controller
* @name AppController
* @description
* This is main controller
**/ 

    angular
    .module('app')
    .controller('AppController', AppController);

    AppController.$inject = ["PedidoService","AsesoramientoService","GenerallabService","PagosService","$uibModal","UserService","StripeService","$timeout","$location",'$anchorScroll'];

    function AppController(PedidoService,AsesoramientoService,GenerallabService,PagosService,$uibModal,UserService,StripeService,$timeout,$location,$anchorScroll)
    {
        var vm = this;
        vm.centro = {};


        vm.stripe = StripeService;
        vm.generalLab = GenerallabService;
        vm.getUser = function(){
        	UserService.getCentroUser().then(function(data){ 
        		vm.generalLab.centro = data.centro;
        		vm.generalLab.numAsesoramientosCentro = data.numAsesoramientosCentro;
            $timeout(function(){
              
            resize();
            })
          	})
        }
        vm.getUser();

        vm.formatDate = function(date){
          var dateOut = new Date(date);
          return dateOut;
        };

        vm.cambiarPass = function(form){
            vm.loading = true;
            UserService.cambiarPass(vm,function(data){
                vm.code = data.code;
                vm.msg = data.msg;
                vm.loading = false;
                    vm.recuperarDatos.mail = "";
            });
        }
        


        vm.popupVenta = "";
        vm.open = function (prod_id) {
            // $timeout(function(){
            //     console.log("lading");
            //   },2000)
            console.log("modal in");
          //zone to inject html modal
          /*var parentElem = parentSelector ? 
            angular.element($document[0].querySelector('.modal-demo ' + parentSelector)) : undefined;*/
            vm.card = true;
            vm.pedido = 0;

            //vm.stripe.init();
           
            //vm.stripe.pedido = data;  
            vm.popupVenta = $uibModal.open({
                animation: true,
                ariaLabelledBy: 'modal-title',
                ariaDescribedBy: 'modal-body',
                templateUrl: 'compra',
                backdrop: 'static',
                controller: function($scope, $timeout ){
                  console.log("modal dentro");
                  $scope.paso = 1;
                  $scope.productos = [];
                  $scope.stripe = vm.stripe;
                   $scope.startCupon = false;
                  AsesoramientoService.getProductosAsesoramiento().then(function(data){
                        $scope.productos = data.productos;
                        if(prod_id){
                            for(var cont=0;cont<data.productos.length;cont++){
                                if(data.productos[cont].id==prod_id){
                                    $scope.cambiarProd(data.productos[cont]);
                                }
                            }
                        }
                        $timeout(function(){
                          
                      $.material.init();
                        })

                  });
                  console.log("prodScope",$scope.prodSelected);
                  
                  $scope.ok = function(){
                  }

                  $scope.getCupon = function(){
                     
                        PagosService.getCupon($scope).then(function(data){ 
                            if(data.cupon){
                               
                                $scope.cupon = data.cupon; 
                                //$scope.vecesPedidoCupon = data.vecesPedidoCupon; 
                                vm.stripe.cupon = data.cupon; 
                              
                                //console.log($scope.vecesPedidoCupon);
                                //$scope.result = ($scope.prodSelected.precio * $scope.cupon.descuento) / 100;
                                $scope.descuento = data.cupon.descuento;
                                $scope.stripe.setAmount(($scope.prodSelected.precio-(($scope.prodSelected.precio*$scope.cupon.descuento)/100)).toFixed(2));
                            }else{
                                $scope.cupon = false; 
                                $scope.stripe.setAmount(($scope.prodSelected.precio*1).toFixed(2));
                            }
                            $scope.startCupon = true;


                                console.log($scope.cupon.descuento);
                                console.log($scope.prodSelected.precio);
                                console.log("multiplciacion",$scope.prodSelected.precio * $scope.cupon.descuento);
                                console.log($scope.result);
                            
                        })
                  }

                  $scope.cambiarProd = function(prod){
                    $scope.selectedProductId = prod.id;
                    $scope.prodSelected = prod;
                    console.log(prod);
                  }

                  console.log("casicasi");
                  $scope.orderComplete = function(result){
                    console.log("entrando...");
                        PedidoService.finalizarPedidoAsesoramiento(result,vm.stripe).then(function(data){ 
                            vm.generalLab.centro.packs = data.packs;
                            $scope.pago_realizado = true;
                            $scope.stripe.loading = false;
                            console.log("entra");

                       })
                    }
                   
                    $scope.cambiarPaso = function(paso){
                        $scope.paso = paso;
                        if(paso==2){
                            $timeout(function() {
                                $scope.stripe.setAmount(($scope.prodSelected.precio*1).toFixed(2));
                                $scope.stripe.setProductId($scope.selectedProductId);
                                $scope.stripe.init();
                              }, 10);
                        }
                    }

                  $scope.ko = function(){
                    vm.popupVenta.close();
                  }
                 
                },
                size: 'lg',
                
            });
        };  
    }


})();